import { Col, Radio, Row, Space } from "antd";

export function AddStatusModalContent({ status, value, setValue }) {

    return (
        <>
            <Radio.Group onChange={(e) => setValue(e.target.value)} value={value} style={{ width: '100%' }}>
                <Row style={{ width: '100%' }}>
                    <Col span={12}>
                        <Space size={20} direction="vertical">
                            {status.slice(0, Math.ceil(status.length / 2)).map(s => (<Radio value={s.value}>{s.title} </Radio>))}
                        </Space>
                    </Col>
                    <Col span={12}>
                        <Space size={20} direction="vertical">
                            {status.slice(Math.ceil(status.length / 2)).map(s => (<Radio value={s.value}>{s.title} </Radio>))}
                        </Space>
                    </Col>
                </Row>
            </Radio.Group>
        </>
    )
}